import { PostComisionContactCenterCalcular } from "../../../reducers/comisionContactCenter";

export interface GeneracionContactCenterStore
  extends PostComisionContactCenterCalcular {}

export const generacionContactCenterStore: (
  state
) => GeneracionContactCenterStore = state => {
  const comisionContactCenterState = state.comisionContactCenter;

  return {
    comisionContactCenterResumen:
      comisionContactCenterState.comisionContactCenterResumen,
    postingComisionContactCenter:
      comisionContactCenterState.postingComisionContactCenter,
    postingComisionContactCenterError:
      comisionContactCenterState.postingComisionContactCenterError
  };
};
